import cx from 'classnames';
import { isNil } from 'lodash-es';
import LazyImage from '../LazyImage';
import styles from './index.less';

export type GoodsImgProps = {
  className?: boolean;
  src: string;
  type?: 'cart' | 'order';
  lazyLoad?: boolean;
  tip?: {
    text: string;
    position?: 'middle' | 'bottom';
    className?: string;
  };
  onClick?: () => void;
};

function GoodsImg({
  className,
  src,
  type = 'order',
  tip,
  onClick,
}: GoodsImgProps) {
  const getTip = () => {
    const { position = 'middle', text, className: tipClassName } = tip || {};
    if (isNil(tip) || text === '') return null;
    return (
      <div className={cx(styles[`${position}Tip`], tipClassName)}>{text}</div>
    );
  };
  return (
    <div
      className={cx(styles.wrapper, styles[`${type}Wrapper`], className)}
      onClick={onClick}
    >
      <LazyImage className={styles.img} src={src} />
      {getTip()}
    </div>
  );
}

export default GoodsImg;
